import axiosInstance from './axiosInstance';

export const createHSAReport = async (patientId, hsaData) => {
  try {
    const response = await axiosInstance.post(
      `/andrology/hsa/create/${patientId}`,
      hsaData,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error creating or updating HSA report:', error);
    return undefined;
  }
};

export const updateHSAReport = async (patientId, hsaData) => {
  try {
    const response = await axiosInstance.put(
      `/andrology/hsa/update/${patientId}`,
      hsaData,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error updating HSA report:', error);
  }
};

export const createQSAReport = async (patientId, qsaData) => {
  try {
    const response = await axiosInstance.post(
      `/andrology/qsa/create/${patientId}`,
      qsaData,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error creating or updating QSA report:', error);
  }
};

export const updateQSAReport = async (patientId, qsaData) => {
  try {
    const response = await axiosInstance.put(
      `/andrology/qsa/update/${patientId}`,
      qsaData,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error updating QSA report:', error);
  }
};

export const createDFIReport = async (patientId, dfiData) => {
  try {
    const response = await axiosInstance.post(
      `/andrology/dfi/create/${patientId}`,
      dfiData,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error creating or updating DFI report:', error);
  }
};

export const updateDFIReport = async (patientId, dfiData) => {
  try {
    const response = await axiosInstance.put(
      `/andrology/dfi/update/${patientId}`,
      dfiData,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error updating DFI report:', error);
  }
};

export const createSFRReport = async (patientId, sfrData) => {
  try {
    const response = await axiosInstance.post(
      `/andrology/sfr/create/${patientId}`,
      sfrData,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error updating DFI report:', error);
  }
};

export const updateSFRReport = async (patientId, sfrData) => {
  try {
    const response = await axiosInstance.put(
      `/andrology/sfr/update/${patientId}`,
      sfrData,
    );
    return response.data;
  } catch (error) {
    console.error('Error updating DFI report:', error);
  }
};

export const updateSFRFreezingInventory = async (patientId, iuiData) => {
  try {
    const response = await axiosInstance.put(
      `/andrology/sfr-freezing-inventory/update/${patientId}`,
      iuiData,
    );
    return response.data;
  } catch (error) {
    console.error('Error updating DFI report:', error);
  }
};

export const createIUIReport = async (patientId, iuiData) => {
  try {
    console.log('iuiData', iuiData);
    const response = await axiosInstance.post(
      `/andrology/iui/create/${patientId}`,
      iuiData,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error updating DFI report:', error);
  }
};

export const updateIUIReport = async (patientId, iuiData) => {
  try {
    const response = await axiosInstance.put(
      `/andrology/iui/update/${patientId}`,
      iuiData,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error updating DFI report:', error);
  }
};

export const updateIUIPregnancyDetails = async (patientId, iuiData) => {
  try {
    const response = await axiosInstance.put(
      `/andrology/iui-pregnancy-details/update/${patientId}`,
      iuiData,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error updating DFI report:', error);
  }
};

export const generateHSAReport = async (patientId, id) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/generate-report/hsa/${patientId}/${id}`,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error generating HSA report:', error);
  }
};

export const generateQSAReport = async (patientId, id) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/generate-report/qsa/${patientId}/${id}`,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error generating QSA report:', error);
  }
};

export const generateDFIReport = async (patientId, id) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/generate-report/dfi/${patientId}/${id}`,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error generating DFI report:', error);
  }
};

export const generateSFRReport = async (patientId, id) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/generate-report/sfr/${patientId}/${id}`,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error generating SFR report:', error);
  }
};

export const generateIUIReport = async (patientId, id) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/generate-report/iui/${patientId}/${id}`,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error generating IUI report:', error);
  }
};

export const sendHSAReport = async (patientId, id) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/send-report/hsa/${patientId}/${id}`,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error sending HSA report:', error);
  }
};

export const sendQSAReport = async (patientId, id) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/send-report/qsa/${patientId}/${id}`,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error sending QSA report:', error);
  }
};

export const sendDFIReport = async (patientId, id) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/send-report/dfi/${patientId}/${id}`,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error sending DFI report:', error);
  }
};

export const sendSFRReport = async (patientId, id, reportId) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/send-report/sfr/${patientId}/${id}/${reportId}`,
    );

    return response.data;
  } catch (error) {
    console.error('Error sending SFR report:', error);
  }
};

export const sendIUIReport = async (patientId, id) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/send-report/iui/${patientId}/${id}`,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error sending IUI report:', error);
  }
};

export const downloadReport = async (fileId) => {
  try {
    const response = await axiosInstance.get(
      `/andrology/download-report/${fileId}`,
    );
    console.log('response', response);
    return response.data;
  } catch (error) {
    console.error('Error downloading report:', error);
  }
};

export const getDataAnalyticsApi = ({ page, pageSize, reportType }) => {
  return axiosInstance
    .get('/andrology/get-data-analytics', {
      params: {
        page,
        pageSize,
        reportType,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching data analytics:', error);
      throw error;
    });
};

export const getSearchedDataAnalyticsApi = ({
  page,
  pageSize,
  searchValue,
  searchByName = false,
  searchByPatientId = false,
  fromDate,
  toDate,
  reportType,
}) => {
  return axiosInstance
    .get(`/andrology/get-data-analytics/search`, {
      params: {
        page,
        pageSize,
        searchValue,
        searchByName: searchByName ? searchByName : undefined,
        searchByPatientId: searchByPatientId ? searchByPatientId : undefined,
        fromDate: fromDate ? fromDate.toISOString() : undefined,
        toDate: fromDate ? toDate.toISOString() : undefined,
        reportType,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching all users:', error);
      throw error;
    });
};

export const downloadDataAnalyticsReportsApi = ({
  searchValue,
  searchByName = false,
  searchByPatientId = false,
  fromDate,
  toDate,
  reportType,
}) => {
  return axiosInstance
    .get('/andrology/get-data-analytics/download', {
      params: {
        searchValue,
        searchByName: searchByName ? searchByName : undefined,
        searchByPatientId: searchByPatientId ? searchByPatientId : undefined,
        fromDate: fromDate ? fromDate.toISOString() : undefined,
        toDate: fromDate ? toDate.toISOString() : undefined,
        reportType,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching data analytics:', error);
      throw error;
    });
};
